import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import Select from '@atlaskit/select';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import { gridSize } from '@atlaskit/theme';

export type AccountEnvOption = { label: string | React.ReactNode; value: string };

const AccountEnvSelectorWrapper = styled.div`
  margin-top: ${gridSize()}px;
`;

export const defaultAccountEnvOptions: AccountEnvOption[] = [
  {
    label: (
      <FormattedMessage
        id="atlassian-cloud-and-data-center-label"
        defaultMessage="Atlassian Cloud and Data Center"
        description="Label for selecting the Atlassian Cloud and Data Center environment"
      />
    ),
    value: 'atlassian-cloud',
  },
  {
    label: (
      <FormattedMessage
        id="atlassian-isolated-cloud-label"
        defaultMessage="Atlassian Isolated Cloud"
        description="Label for selecting the Atlassian Isolated Cloud environment"
      />
    ),
    value: 'atlassian-isolated-cloud',
  },
];

export type AccountEnvSelectorProps = {
  isHidden?: boolean;
  options?: AccountEnvOption[];
  onSelectEnvChange?: (value: string) => void;
  fieldError?: string;
  isRequired?: boolean;
  isInvalid?: boolean;
};

const AccountEnvSelector = ({
  isHidden = false,
  options,
  onSelectEnvChange,
  fieldError,
  isRequired,
  isInvalid,
}: AccountEnvSelectorProps) => {
  if (isHidden) return null;

  return (
    <AccountEnvSelectorWrapper>
      <Label
        htmlFor="account-env-selector"
        aria-required={isRequired}
        aria-label="Environment"
        id="account-env-selector-label">
        <FormattedMessage
          id="account-env-selector-label"
          defaultMessage="Environment"
          description="Label for the account environment selector"
        />
        <RequiredAsterisk />
      </Label>
      <Select<AccountEnvOption, false>
        placeholder={
          <FormattedMessage
            id="account-env-selector-placeholder"
            defaultMessage="Select Environment"
            description="Placeholder for the account env selector"
          />
        }
        isRequired={isRequired}
        options={options}
        isClearable={false}
        inputId="account-env-selector"
        testId="account-env-selector-idf-testid"
        onChange={selected => onSelectEnvChange?.(selected ? selected.value : '')}
        isInvalid={isInvalid}
        invalidMessage={fieldError}
      />
    </AccountEnvSelectorWrapper>
  );
};

export default AccountEnvSelector;
